import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import { useGetQR } from "hooks/useGetQR";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import { RoutePaths } from "constants/RoutePaths";

const PageBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  backgroundColor: theme.palette.common.white,
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
}));

const HeaderRow = styled(Stack)({
  flexDirection: "row",
  alignItems: "center",
});

const TitleTypography = styled(Typography)({
  flex: 1,
  fontWeight: 600,
});

const DescriptionTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const QrCenterContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  marginTop: "20vh",
});

const RefreshButton = styled(LoadingButton)({
  marginTop: "10rem",
});

const ConfirmationNumberTypography = styled(Typography)({
  fontSize: "70px",
});

const QrCodeContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
}));

export const MobileQrPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isVeryLargeScreen = useMediaQuery("(min-width:2200px)");
  const qrCodeSize = isVeryLargeScreen ? 220 : 280;
  const confirmationNumberSize = isVeryLargeScreen ? "56px" : "70px";
  const {
    data: qrData,
    loading,
    error,
    refetch,
  } = useGetQR();

  return (
    <PageBox>
      <HeaderRow>
        <IconButton
          aria-label="back"
          onClick={() => navigate(RoutePaths.HOME)}
          size="small"
        >
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <TitleTypography variant="h6">{t("navbar.home")}</TitleTypography>
      </HeaderRow>

      <DescriptionTypography variant="body2">
        {t("qrModal.scanQrCodeToLogin")}
      </DescriptionTypography>

      <QrCenterContainer>
        {loading || error ? (
          <CircularProgress />
        ) : (
          <QrCodeContainer>
            <QRCode value={qrData?.qr ?? ""} size={qrCodeSize} />
            <ConfirmationNumberTypography
              variant="body2"
              align="center"
              sx={{ fontSize: confirmationNumberSize }}
            >
              {qrData?.confirmationNumber}
            </ConfirmationNumberTypography>
          </QrCodeContainer>
        )}
      </QrCenterContainer>

      <RefreshButton
        loading={loading}
        onClick={() => refetch()}
        variant="contained"
        fullWidth
      >
        {t("common.refresh")}
      </RefreshButton>
    </PageBox>
  );
};
